<div class="auth-wrapper">
    <div class="spin_block" *ngIf="isload">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>

    <div class="auth-inner">
        <!-- Background Side (Hidden on mobile) -->
        <div class="auth-bg-side">
            <img src="assets/img/vms.png" alt="Visitor Management System" class="bg-img">
        </div>

        <!-- Form Side -->
        <div class="auth-form-side">
            <div class="form-container">
                <!-- Brand Logo & Name -->
                <div class="auth-logo">
                    <img src="assets/img/logo.png" alt="logo">
                    <div class="brand-name">Visitor Management System</div>
                </div>

                <!-- Form Header -->
                <div class="auth-header">
                    <h2>Login</h2>
                    <p>Enter your credentials to access your account</p>
                </div>

                <form>
                    <!-- Username Input -->
                    <div class="form-group">
                        <label for="username">User Name</label>
                        <div class="input-group">
                            <input type="text" id="username" class="form-control" name="Username"
                                [(ngModel)]="addD.Username" (keyup.enter)="focus_Next()" placeholder="Enter your username"
                                autocomplete="username">
                        </div>
                    </div>

                    <!-- Password Input -->
                    <div class="form-group">
                        <label for="password">Password</label>
                        <div class="input-group">
                            <input [type]="showPassword ? 'text' : 'password'" id="password"
                                class="form-control password has-icon" name="Password" [(ngModel)]="addD.Password"
                                (keyup.enter)="login()" placeholder="••••••••" required autocomplete="current-password">
                            
                            <span class="password-toggle" (click)="togglePasswordVisibility()">
                                <i [class]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
                            </span>
                        </div>
                    </div>

                    <!-- Error Message -->
                    <div class="error-msg" *ngIf="error_">
                        {{error_}}
                    </div>

                    <!-- Forgot Password -->
                    <div class="forgot-password">
                        <span (click)="get_Password()">Forgot Password?</span>
                    </div>

                    <!-- Login Button -->
                    <button type="button" class="btn btn-login" (click)="login()" [disabled]="btndisable">
                        <span *ngIf="btndisable" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                        {{ btndisable ? 'Authenticating...' : 'Login' }}
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>